import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import {
  useAppEvenListSelector,
  useAppEventGameListSelector,
  useAppGameDetailsSelector,
} from "src/_common/hooks/selectors/eventSelector";
import { CRYPTO_SECRET_KEY } from "src/_config";

// interface SponsorProps {
//     details?: any
// }

import Cryptr from "cryptr";
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function Sponsor() {
  const [details, setDetails] = useState<{ id?: number; original?: string } | null>(null);
  const { eventId, taskId } = useParams<{ eventId?: string; taskId?: string }>();
  const [link, setLink] = useState<string | null>(null);

  const gameDetails = useAppGameDetailsSelector() as { sponsor_image?: { id?: number; original?: string }; sponsor_link?: string } | null;
  const eventList = useAppEvenListSelector() as { list?: Array<Record<string, unknown> & { id?: number; rodeo_event_game_info?: { sponsor?: { id?: number; original?: string }; sponsor_link?: string } }> } | null;
  const taskList = useAppEventGameListSelector() as Array<Record<string, unknown> & { id?: number; sponsor?: { sponsor?: { id?: number; original?: string } } }> | null;

  useEffect(() => {
    // console.log({details})
  }, [details]);

  useEffect(() => {
    // if (taskId) {
    const t_id = taskId ? parseInt(cryptr.decrypt(taskId)) : null;
    const task = taskList?.find((x) => x.id == t_id);
    console.log({ task });
    if (task?.sponsor?.sponsor) {
      setDetails(task?.sponsor?.sponsor);
      return;
    }
    if (eventId) {
      const e_id = parseInt(cryptr.decrypt(eventId));
      const r_event = eventList?.list?.find((x) => x.id == e_id);
      if (r_event?.rodeo_event_game_info?.sponsor) {
        setLink(r_event?.rodeo_event_game_info?.sponsor_link ?? null);
        setDetails(r_event?.rodeo_event_game_info?.sponsor);
      }
    } else {
      if (gameDetails?.sponsor_image) {
        setLink(gameDetails?.sponsor_link ?? null);
        setDetails(gameDetails?.sponsor_image);
      }
    }
  }, [eventId, gameDetails, eventList, taskId, taskList]);

  return (
    <>
      {details?.id != 0 && details?.original ? (
        <div className="sponsor-com-img-wrap">
          <span>Sponsored by:</span>
          {link ? (
            <a href={link}>
              <img src={details?.original} alt="Sponsor Image" />
            </a>
          ) : (
            <a>
              <img src={details?.original} alt="Sponsor Image" />
            </a>
          )}
        </div>
      ) : null}
    </>
  );
}
